module.exports = __webpack_public_path__ + "img/text.ff698b54.png";